import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { initialConfig } from 'ngx-mask';


export interface MaskOptions {
  mask: string;
  prefix?: string;
  suffix?: string;
  dropSpecialCharacters?: boolean;
  clearIfNotMatch?: boolean;
  validation?: boolean;
  showMaskTyped?: boolean;
}
@Component({
  selector: 'app-formly-mask-type',
  template: `
    <mat-form-field [class]="to.className" appearance="fill">
      <mat-label>{{ to.label }}</mat-label>
      <input
        matInput
        [type]="to.type || 'text'"
        [id]="id"
        [readonly]="to.readonly"
        [prefix]="to.maskOptions.prefix || ''"
        [suffix]="to.maskOptions.suffix || ''"
        [clearIfNotMatch]="to.maskOptions.clearIfNotMatch"
        [showMaskTyped]="to.maskOptions.showMaskTyped"
        [dropSpecialCharacters]="to.maskOptions.dropSpecialCharacters"
        [validation]="to.maskOptions.validation"
        [mask]="to.maskOptions.mask"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [tabindex]="to.tabindex || 0"
        [placeholder]="placeholderLabel"
        [patterns]="patterns"
        thousandSeparator=","
      />
      <mat-error>
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </mat-form-field>
  `,

  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormlyMaskTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  defaultOptions = {
    templateOptions: {
      maskOptions: {
        mask: '',
        dropSpecialCharacters: true,
        clearIfNotMatch: true,
        validation: true,
        showMaskTyped: false,
        prefix: '',
        suffix: '',
      },
    },
  };
  patterns = initialConfig.patterns;
  get placeholderLabel() {
    const text = this.to.placeholder || this.to.label;
    return this.to.required ? text + ' *' : text;
  }
  ngOnInit() {
    this.patterns = { ...this.patterns, ...this.to.maskOptions.patterns };
  }
}
